const countyConfigUserPurgeNowReducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER_PURGE_NOW':
          return action.data;
    default:
          return state;
  }
}

export default countyConfigUserPurgeNowReducer;